<template>
    <div id="viewCreativeVue">
        <div
            v-if="isOpen"
            class="modal slide-in-top d-block"
            id="viewCreativeModal"
            tabindex="-1"
            role="dialog"
            aria-hidden="false"
            @click.self="close"
        >
            <div
                class="modal-dialog modal-dialog-centered modal-md"
                role="document"
            >
                <view-creative-carousel
                    :creative-ids="creativeIds"
                    :order-id="orderId"
                    @close="close"
                />
            </div>
        </div>
        <div v-if="isOpen" class="modal-backdrop fade show" @click="close"></div>
    </div>
</template>

<script>
export default {
    name: 'ViewCreativeModal',

    data() {
        return {
            isOpen: false,
            creativeIds: [],
            orderId: null,
        };
    },

    mounted() {
        this._openHandler = this.open.bind(this);
        this._closeHandler = this.close.bind(this);

        // Listen for Vue Bus events
        Bus.$on('openViewCreative', this._openHandler);
        Bus.$on('closeViewCreative', this._closeHandler);

        // Bridge Livewire events to Vue
        this.setupLivewireBridge();
    },

    beforeDestroy() {
        Bus.$off('openViewCreative', this._openHandler);
        Bus.$off('closeViewCreative', this._closeHandler);
    },

    methods: {
        /**
         * Setup bridge between Livewire events and Vue.
         * This allows Livewire components to trigger the Vue modal.
         */
        setupLivewireBridge() {
            if (typeof window.Livewire !== 'undefined') {
                this.registerLivewireListeners();
            } else {
                document.addEventListener('livewire:init', () => {
                    this.registerLivewireListeners();
                });
            }
        },

        /**
         * Register Livewire event listeners that forward to Vue.
         */
        registerLivewireListeners() {
            // Listen for Livewire 'openViewCreative' event
            window.Livewire.on('openViewCreative', (data) => {
                // Livewire 3 passes data as an array
                if (Array.isArray(data)) {
                    const [creativeIds, orderId] = data;
                    this.open(creativeIds, orderId);
                } else if (data && typeof data === 'object') {
                    // Handle object format
                    this.open(
                        data.creativeIds || data.creative_ids || [],
                        data.orderId || data.order_id,
                    );
                }
            });

            // Listen for Livewire 'closeViewCreative' event
            window.Livewire.on('closeViewCreative', () => {
                this.close();
            });
        },

        /**
         * Open the modal with the given creative IDs and order ID.
         *
         * @param {number[]} creativeIds - Array of creative IDs to view
         * @param {number} orderId - The order ID
         */
        open(creativeIds, orderId) {
            this.creativeIds = creativeIds;
            this.orderId = orderId;
            this.isOpen = true;

            // Add modal-open class to body to prevent scrolling
            document.body.classList.add('modal-open');
        },

        /**
         * Close the modal.
         */
        close() {
            // Reset state
            this.orderId = null;
            this.creativeIds = [];
            this.isOpen = false;

            // Remove modal-open class from body
            document.body.classList.remove('modal-open');

            // Emit generic close event
            Bus.$emit('viewCreativeClosed');
        },
    },
};
</script>

<style scoped>
.modal {
    background-color: rgba(0, 0, 0, 0.5);
}

.modal-backdrop {
    z-index: 1040;
}

.modal {
    z-index: 1050;
}

.slide-in-top {
    animation: slideInTop 0.3s ease-out;
}

@keyframes slideInTop {
    from {
        opacity: 0;
        transform: translateY(-20px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}
</style>